export default __webpack_public_path__ + "static/media/clock.12ae30b1.svg";